import { Typography, Box, Grid, Stack } from "@mui/material";

export default function LeaderboardSettings({ rawData }) {
  if (!rawData) {
    return (
      <Typography color="error" variant="body2">
        Invalid or empty JSON data
      </Typography>
    );
  }
  return (
    <Stack spacing={1} sx={{ p: 0, flex: 1, justifyContent: 'center' }}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <Typography variant="body2" sx={{
              color: 'text.secondary',
              fontSize: '0.7rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              mb: 0.5,
            }}>
              Rank Strategy
            </Typography>
            <Typography variant="subtitle2" sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '0.8rem',
            }}>
              {rawData ? `${String(rawData.rankStrategy)}` : "N/A"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <Typography variant="body2" sx={{
              color: 'text.secondary',
              fontSize: '0.7rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
              mb: 0.5,
            }}>
              Prize Strategy
            </Typography>
            <Typography variant="subtitle2" sx={{
              fontWeight: 700,
              color: 'text.primary',
              fontSize: '0.8rem',
            }}>
              {rawData ? `${String(rawData.sharePrizeStrategy)}` : "N/A"}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  )
}
